import React, { useLayoutEffect, useState } from 'react'
import { useLocation, useParams } from "react-router";
import { getFormattedDate } from '../../../common/date';
import { Link, useNavigate } from 'react-router-dom';
import Table from '../../../components/Common/Table';
import TableNoRecords from '../../../components/Common/Table/TableNoRecords';
import Pagination from '../../../components/Pagination'
import { Context } from '../../../config/store';
import LenderUgroService from '../../../services/lender';
import AdditionalInfoColumns from './AdditionalInfoColumns';
import AdditionalInfoModal from './AdditionalInfoModal';
import './style.css'
import SearchFilter from './SearchFilter';
import UcoCollectionLogsColumns from './UcoCollectionLogsColumns';

const AdditionalInfoupload = () => {
  const location = useLocation();
  let heading = location.pathname.split('/')?.[2]
  let lenderId = location.pathname.split('/')?.[3]

  const [title, setTitle] = React.useState('')
  const { state } = React.useContext(Context);
  const leadId = useParams().id;

  const [tableData, setTableData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
  const [pagination, setPaginationData] = React.useState({});
  const [page, setPage] = React.useState(1);
  const [permission, setPermission] = useState('')
  const [queryParams, setQueryParams] = React.useState('');  
  const [usersList, setUsersList] = useState([])
  const navigate = useNavigate();
  const [selectedColender, setselectedColender] = useState(localStorage.getItem('selectedColender'))
  const lenders = {15: 'UCO', 16: 'KVB', 20: 'KARNATAKA'};
  const [showLogs, setShowLogs] = useState(false);
  const [logsTableData, setLogsTableData] = React.useState([]);
  const [logsLoading, setLogsLoading] = React.useState(true);
  const [logsError, setLogsError] = React.useState(false);
  const [logsErrorMessage, setLogsErrorMessage] = React.useState("");
  const [logsPagination, setLogsPaginationData] = React.useState({});
  const [logsPage, setLogsPage] = React.useState(1);

  useLayoutEffect(() => {
    if (heading === 'credit') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)} Info`)
      setPermission('add-credit-info')
    } else if (heading === 'operations') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)} Info`)
      setPermission('add-operations-info')
    } else if (heading === 'utr') {
      setTitle(`${heading.toUpperCase()} Info`)
      setPermission('add-nbfc-info')
    } else if (heading === 'cersai') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)}  Info`)
      setPermission('add-cersai-info')
    } else if (heading === 'machinery') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)}  Info`)
      setPermission('add-machinery-info')
    } else if (heading === 'lap') {
      setTitle(`${heading.toUpperCase()}  Info`)
      setPermission('add-lap-info')
    } else if (heading === 'collateral') {
      setTitle(`${heading.toUpperCase()}  Info`)
      setPermission('add-collateral-info')
    } else if (heading === 'collection') {
      setTitle(`${(lenders[lenderId] || '')} ${heading.toUpperCase()}  Info`)
      setPermission('add-collection-info')
    }

  }, [heading])

  const toggleModal = () => {
    setModalState(!modalState)
  }
  useLayoutEffect(() => {
    getbulkfundoutList()
  }, [page, heading, queryParams])
  const getbulkfundoutList = async () => {
    setTableData([]);
    setLoading(true);
    setError(false);
    setErrorMessage("");
    try {
      const response = await LenderUgroService.getbulkfundoutList(page, heading, queryParams, lenderId);
      let usersresponseList = response?.data?.data?.users
			let userItems = usersresponseList?.map((response) => ({
				label: response.full_name,
				value: response.user_id,
			}));
			setUsersList(userItems);
      const data = response.data.data?.fundout_files?.data;
      const pagination_data = response.data.data?.fundout_files?.pagination;
      setPaginationData(pagination_data || {})
      // console.log(data)
      setTableData(data);
      setLoading(false);
    } catch (err) {
      setError(true);
      setErrorMessage(
        err.response?.data?.messages?.error?.form[0] ||
        err.response?.data?.messages?.error?.others[0] ||
        "Failed to load bulk found detail"
      );
    }
  };
  useLayoutEffect(() => {
    if(showLogs){
      getLenderCollectionLogs()
    }
  }, [logsPage], showLogs)
  const getLenderCollectionLogs = async () => {
    setPage(1);
    setShowLogs(true);
    setLogsTableData([]);
    setLogsLoading(true);
    setLogsError(false);
    setLogsErrorMessage("");
    try {
      const response = await LenderUgroService.getLenderCollectionLogs({logsPage, heading});
      const logsData = response.data.data?.logs?.data;
      const page_data = response.data.data?.logs?.pagination;
      setLogsPaginationData(page_data || {})
      setLogsTableData(logsData);
      setLogsLoading(false);
    } catch (err) {
      setLogsError(true);
      setLogsErrorMessage(
        err.response?.data?.messages?.error?.form[0] ||
        err.response?.data?.messages?.error?.others[0] ||
        "Failed to load logs"
      );
    }
  };
  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };

  return (
    <div>
      <div className='mt-3'>
        <span className='heading  text-underline'>{title}</span>
      </div>
      {heading === 'collection' && <div className='d-flex'>
        <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', position: "fixed", top: "20px", cursor: "pointer", left: state.sidebarOpen ? "235px" : "60px" }} onClick={() => navigate(selectedColender)}>
          <div style={{ border: "1px solid #4A4E88", borderRadius: "50%", color: "#4A4E88", padding: "1px 1px 1px 5px", justifyContent: "center", alignItems: "center", marginRight: "2px" }}>
            <i className='fa fa-chevron-left mr-1'></i>
          </div>
          <Link style={{ textDecoration: "underline", color: "#4A4E88", fontWeight: "600" }}>BACK</Link>
        </div>
      </div>}
      <>
        {!showLogs && <SearchFilter setQueryParams={setQueryParams} usersList={usersList} heading={heading} loading={loading}/>}
        <div className="row no-gutters align-items-center mt-3 flex-row-reverse" style={{gap:'10px'}}>
          <div></div>
          <div className="mb-2">
            {(checkHasPermission(permission) && lenderId == 15) &&
              (!showLogs ? <button className="btn btn-custom btn-custom-height" onClick={()=>{
                getLenderCollectionLogs()
              }}>
                View Logs
              </button>
                :
                <button className="btn btn-custom btn-custom-height" onClick={() => {
                  setShowLogs(false)
                  setLogsPage(1);
                }
                }>
                  View Collections
                </button>
              )}
          </div>
          <div className="mb-2">
            {(checkHasPermission(permission) && !showLogs) && <button className="btn btn-custom btn-custom-height" onClick={toggleModal}>
              {`Add ${heading.charAt(0).toUpperCase() + heading.substring(1)} Info `}
            </button>}
            {modalState && (
              <AdditionalInfoModal
                userType={state.userType}
                state={modalState}
                toggleModal={toggleModal}
                leadId={leadId}
                reloadTable={getbulkfundoutList}
              />
            )}
          </div>
        </div>
        {
          !showLogs ? (
            !error ? (
              <div className="bulkfundout_table_css">
                <Table
                  columns={AdditionalInfoColumns}
                  checkbox={false}
                  rows={tableData}
                  loading={loading}
                  // type="paymentData"
                  tableExtraClass={""}
                  reloadTable={getbulkfundoutList}
                  heading={heading}
                >
                  {tableData.length == 0 && !loading && <TableNoRecords />}
                </Table>
              </div>
            ) : <div className="bulkfundout_table_css">
              <Table
                columns={AdditionalInfoColumns}
              >
                {true && <TableNoRecords />}
              </Table>
            </div>
        )
           :
            !logsError ? (
              <div>
                <div className="bulkfundout_table_css">
                  <Table
                    columns={UcoCollectionLogsColumns}
                    checkbox={false}
                    rows={logsTableData}
                    loading={logsLoading}
                    tableExtraClass={""}
                    reloadTable={getLenderCollectionLogs}
                    heading={heading}
                  >
                    {logsTableData.length == 0 && !logsLoading && <TableNoRecords />}
                  </Table>
                </div>
              </div>
            ) :
              <div className="bulkfundout_table_css">
                <Table
                  columns={UcoCollectionLogsColumns}
                >
                  {true && <TableNoRecords />}
                </Table>
              </div>
        }
        {
          !showLogs ? (
            <Pagination
              setPage={setPage}
              total_pages={pagination?.total_pages}
              total={pagination?.total}
              currentPageNumber={page}
            />
          ) : (
            <>
            <Pagination
              setPage={setLogsPage}
              total_pages={logsPagination?.total_pages}
              total={logsPagination?.total}
              currentPageNumber={logsPage}
            />
            </>
          )
        }
      </>
    </div>
  )
}
export default AdditionalInfoupload



